import { useNavigate } from 'react-router-dom';
import { isLogin } from '../../../utils/auth';
import styled, { css } from 'styled-components';
import { useEffect, useState } from 'react';
import UserService from '../../../service/User';
import MembershipBadge from '../../components/membership/MembershipBadge';
import { useUser } from '../../../context/UserContext';
import ServiceList from './ServiceList';
import { Service1, Service2, Service3 } from './data';
import MenuTop from '../pageTop/MenuTop';
import { PageContainer } from '../common/PageComponent.style';
import { logoutCore } from '../../../func/logout';
import RemainingTickets from './RemainingTickets';

interface Props {
  isModal?: boolean;
  onClose?: () => void;
}

const Menu = ({ isModal, onClose }: Props) => {
  const navigate = useNavigate();
  const { user } = useUser();

  const handleLogout = () => {
    logoutCore();
    navigate('/');
  };

  return (
    <PageContainer $bg="#f3f4f6">
      <MenuTop isModal={isModal} onClose={onClose} />
      <Content>
        {isLogin() ? (
          <Section $gap={16}>
            <UserInfoWrapper>
              {user && (
                <UserTitle>
                  <UserName>{user.name}</UserName> 님 환영합니다!
                </UserTitle>
              )}
              <FixUserInfoButton
                onClick={() => {
                  navigate('/mypage');
                }}
              >
                마이페이지
                <img src="/assets/images/arrow/arrow-right-gray.svg" alt="" />
              </FixUserInfoButton>
            </UserInfoWrapper>
            {user && <MembershipBadge data={user} page="quickmenu" />}
            <MyOption>
              <MyOptionButton
                onClick={() => {
                  navigate('/mypage');
                  sessionStorage.setItem('mypageTab', 'interest');
                }}
              >
                내 관심물건
              </MyOptionButton>
              <MyOptionDivider />
              <MyOptionButton
                onClick={() => {
                  navigate('/mypage');
                  sessionStorage.setItem('mypageTab', 'recent');
                }}
              >
                최근 열람 물건
              </MyOptionButton>
              <MyOptionDivider />
              <MyOptionButton
                onClick={() => {
                  navigate('/mypage');
                  sessionStorage.setItem('mypageTab', 'myinfo');
                }}
              >
                내 정보 수정
              </MyOptionButton>
            </MyOption>
            <RemainingTickets />
          </Section>
        ) : (
          <Section>
            <GuestSection>
              <StartText>손쉽게 시작하는 현명한 투자!</StartText>
              <LoginSection>
                <LoginButton onClick={() => navigate('/login')}>
                  땅집고옥션 로그인
                </LoginButton>
                <UserInfoWrapper>
                  <GuestTextButton onClick={() => navigate('/find')}>
                    아이디 ∙ 비밀번호 찾기
                  </GuestTextButton>
                  <GuestTextButton onClick={() => navigate('/signup')}>
                    회원가입
                  </GuestTextButton>
                </UserInfoWrapper>
              </LoginSection>
            </GuestSection>
          </Section>
        )}
        <BalanceBox
          onClick={() => {
            navigate('/game');
          }}
        >
          <FirstBox>
            <ImgBox>
              <img src="/assets/images/icon/icon_trophy.svg" />
            </ImgBox>
            <div>
              <LastText>나한테 딱 맞는 경매 물건은?</LastText>
              <FirstText>
                경매 밸런스 게임 바로가기
                <Marker>NEW</Marker>
              </FirstText>
            </div>
          </FirstBox>
          <LastBox>
            <img src="/assets/images/arrow/Arrow-right-white.svg" />
          </LastBox>
        </BalanceBox>
        <ServiceList list={Service1} />
        <ServiceList list={Service2} />
        <ServiceList list={Service3} />
        {isLogin() && (
          <LogoutSection>
            <LogoutButton onClick={handleLogout}>로그아웃</LogoutButton>
          </LogoutSection>
        )}
      </Content>
    </PageContainer>
  );
};

export default Menu;

const Content = styled.div`
  display: flex;
  width: 100%;
  padding: 12px 16px 80px 16px;
  flex-direction: column;
  align-items: flex-start;
  gap: 16px;
  background: #f3f4f6;
`;

const Section = styled.div<{ $gap?: number }>`
  display: flex;
  padding: 20px 16px;
  flex-direction: column;
  align-items: flex-start;
  gap: ${({ $gap }) => `${$gap}px`};
  align-self: stretch;
  border-radius: 16px;
  background: #fff;
  box-shadow: 0 2px 10px 0 rgba(220, 228, 232, 0.3);
`;

const UserInfoWrapper = styled.div`
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  align-self: stretch;
`;

const UserTitle = styled.div`
  display: flex;
  align-items: center;
  gap: 2px;

  color: #222;
  font-size: 14px;
  font-weight: 500;
  line-height: 145%;
  letter-spacing: -0.28px;
`;

const UserName = styled.div`
  color: #008aff;
  font-size: 14px;
  font-weight: 700;
  line-height: 145%;
  letter-spacing: -0.28px;
`;

const FixUserInfoButton = styled.div`
  display: flex;
  align-items: center;

  color: #616161;
  text-align: center;
  font-size: 14px;
  font-weight: 500;
  line-height: 145%;
  letter-spacing: -0.28px;
`;

const MyOption = styled.div`
  display: flex;
  align-items: center;
  align-self: stretch;
  border-radius: 8px;
  background: #f3f4f6;
`;

const MyOptionButton = styled.div`
  display: flex;
  padding: 12px 16px;
  justify-content: center;
  align-items: center;
  flex: 1 0 0;
  border-radius: 8px;

  color: #616161;
  text-align: center;
  font-size: 13px;
  font-weight: 500;
  line-height: 145%;
  letter-spacing: -0.26px;
`;

const MyOptionDivider = styled.div`
  width: 1px;
  height: 14px;
  background: #e1e2e4;
`;

const LogoutSection = styled.div`
  display: flex;
  padding: 0 16px;
  flex-direction: column;
  align-items: center;
  gap: 16px;
  align-self: stretch;
  border-radius: 16px;
  background: #fff;
  box-shadow: 0 2px 10px 0 rgba(220, 228, 232, 0.3);
`;

const LogoutButton = styled.div`
  display: flex;
  padding: 10px;
  justify-content: center;
  align-items: center;
  align-self: stretch;
  border-radius: 8px;

  color: rgba(0, 12, 30, 0.8);
  font-size: 14px;
  font-weight: 500;
  line-height: 145%;
  letter-spacing: -0.28px;

  &:active {
    background: rgba(2, 32, 71, 0.05);
  }
`;

const GuestSection = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 8px;
  align-self: stretch;
`;

const StartText = styled.div`
  width: 100%;
  color: #222;
  text-align: center;
  font-size: 14px;
  font-weight: 500;
  line-height: 145%;
  letter-spacing: -0.28px;
`;

const LoginSection = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 16px;
  align-self: stretch;
`;

const LoginButton = styled.div`
  display: flex;
  padding: 14px 0;
  justify-content: center;
  align-items: center;
  gap: 10px;
  align-self: stretch;
  border-radius: 8px;
  background: #008aff;

  color: #fff;
  text-align: center;
  font-size: 16px;
  font-weight: 700;
  line-height: 145%;
  letter-spacing: -0.32px;
`;

const GuestTextButton = styled.div`
  color: #616161;
  font-size: 14px;
  font-weight: 500;
  line-height: 145%;
  letter-spacing: -0.28px;
`;
const BalanceBox = styled.div`
  display: flex;
  flex-direction: row;
  width: 100%;
  padding: 16px;
  justify-content: space-between;
  align-items: center;
  border-radius: 16px;
  background: #1957c2;
  cursor: pointer;
`;
const FirstBox = styled.div`
  display: flex;
  gap: 12px;
  flex-direction: row;
  align-items: center;
  > div {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: 2px;
  }
`;

const ImgBox = styled.div`
  display: flex;
  padding: 4px;
  justify-content: center;
  align-items: center;
  gap: 10px;
  border-radius: 6px;
  background: #f3f4f6;
  width: 28px;
  height: 28px;
  img {
    widht: 20px;
    height: 20px;
  }
`;
const LastBox = styled.div`
  img {
    height: 15px;
  }
`;
const FirstText = styled.div`
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 4px;
  /* Re_SPOQA/body/b_15 */
  font-family: 'Spoqa Han Sans Neo';
  font-size: 15px;
  font-style: normal;
  font-weight: 700;
  line-height: 150%; /* 22.5px */
  letter-spacing: -0.3px;
`;

const Marker = styled.div`
  display: flex;
  padding: 1px 7px;
  justify-content: center;
  align-items: center;
  border-radius: 999px;
  background: #f0f8ff;
  color: #008aff;
  font-size: 10px;
  font-style: normal;
  font-weight: 500;
  line-height: 145%; /* 14.5px */
  letter-spacing: -0.2px;
`;

const LastText = styled.div`
  color: #f0f8ff;

  font-size: 12px;
  font-style: normal;
  font-weight: 500;
  line-height: 145%; /* 17.4px */
  letter-spacing: -0.24px;
`;
